"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComboButton = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var button_1 = require("../button");
var angle_down_1 = __importDefault(require("adp-react-icons/lib/fa/angle-down"));
var vdl_prefix_1 = require("../util/vdl-prefix");
var list_1 = require("../list");
var portal_1 = require("../portal");
var react_focus_lock_1 = __importDefault(require("react-focus-lock"));
var ComboButton = function ComboButton(props) {
  var _a = react_1.useState({}),
    coords = _a[0],
    setCoords = _a[1];
  var _b = react_1.useState(0),
    parentElementWidth = _b[0],
    setParentElementWidth = _b[1];
  var _c = react_1.useState(props.open),
    isOn = _c[0],
    setOn = _c[1];
  var listID = props.listID,
    onSelect = props.onSelect,
    _onClick = props.onClick,
    portalTarget = props.portalTarget,
    data = props.data,
    id = props.id,
    className = props.className,
    disabled = props.disabled,
    label = props.label;
  var buttonRef = react_1.useRef();
  var isPrimary = props.buttonStyle !== 'secondary';
  var closeAll = function closeAll() {
    setOn(false);
  };
  var prepCoords = function prepCoords(e) {
    var rect = e.parentElement.parentElement.getBoundingClientRect();
    setCoords({
      top: Math.ceil(rect.top) + 30,
      left: Math.ceil(rect.left)
    });
  };
  var onSelectItem = function onSelectItem(labels, selectedText) {
    var sel = labels.findIndex(function (lbl) {
      return lbl === selectedText;
    });
    data[sel].action && data[sel].action(selectedText);
    onSelect && onSelect(data[sel]);
    closeAll();
    return selectedText;
  };
  var renderPopup = function renderPopup() {
    var labels = data.map(function (item) {
      return item.label || item;
    }) || [];
    var renderList = react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('combo-button-popup-inner'),
      style: {
        width: parentElementWidth + "px"
      }
    }, react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('combo-button-arrow-up-border')
    }), react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('combo-button-arrow-up')
    }), react_1.default.createElement("div", null, react_1.default.createElement(react_focus_lock_1.default, {
      autoFocus: true,
      returnFocus: true
    }, react_1.default.createElement(list_1.List, {
      data: labels,
      id: listID ? listID : null,
      "aria-live": isOn && 'polite',
      "aria-hidden": !isOn,
      onSelect: function onSelect(selectedText) {
        onSelectItem(labels, selectedText);
      }
    }))));
    return portalTarget ? react_1.default.createElement(portal_1.Portal, {
      targetID: portalTarget
    }, react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('combo-button-portal'),
      style: {
        left: coords['left'] + "px",
        top: coords['top'] + "px",
        minWidth: parentElementWidth + "px"
      }
    }, renderList)) : react_1.default.createElement("div", {
      className: vdl_prefix_1.vdlPrefix('combo-button-popup'),
      style: {
        minWidth: parentElementWidth + "px"
      }
    }, renderList);
  };
  react_1.useEffect(function () {
    var timer;
    var scroll;
    setCoords(coords);
    var portalNode = document.getElementById(portalTarget);
    if (portalTarget) {
      portalNode && portalNode.addEventListener('click', function () {
        timer = setTimeout(function () {
          return closeAll();
        }, 100);
      });
      scroll = document.addEventListener('scroll', function () {
        return closeAll();
      });
    }
    return function () {
      if (portalNode) {
        document.removeEventListener('scroll', scroll);
        clearTimeout(timer);
      }
    };
  }, [coords, parentElementWidth, isOn]);
  return react_1.default.createElement("div", {
    id: id || null,
    className: className ? vdl_prefix_1.vdlPrefix('combo-button') + " " + className : vdl_prefix_1.vdlPrefix('combo-button')
  }, react_1.default.createElement("div", {
    className: vdl_prefix_1.vdlPrefix('combo-button-relative-nest')
  }, react_1.default.createElement(button_1.Button, {
    disabled: disabled,
    buttonStyle: isPrimary ? 'primary' : 'secondary',
    className: vdl_prefix_1.vdlPrefix('combo-button-submit'),
    onClick: function onClick() {
      _onClick(label);
    }
  }, react_1.default.createElement("div", {
    className: vdl_prefix_1.vdlPrefix('combo-button-submit-label')
  }, label)), react_1.default.createElement("button", {
    ref: function ref(_ref) {
      if (_ref && _ref['offsetParent']) {
        setParentElementWidth(_ref['offsetParent']['offsetWidth']);
        prepCoords(_ref);
        buttonRef = _ref;
      }
    },
    onClick: function onClick() {
      !isOn && prepCoords(buttonRef);
      setOn(!isOn);
    },
    className: isPrimary ? vdl_prefix_1.vdlPrefix('combo-button-caret') : vdl_prefix_1.vdlPrefix('combo-button-caret-secondary')
  }, react_1.default.createElement(angle_down_1.default, null))), isOn && renderPopup());
};
exports.ComboButton = ComboButton;
exports.ComboButton.propTypes = {
  buttonStyle: prop_types_1.default.oneOf(['primary', 'secondary']),
  className: prop_types_1.default.string,
  label: prop_types_1.default.string.isRequired,
  id: prop_types_1.default.string,
  disabled: prop_types_1.default.bool,
  open: prop_types_1.default.bool,
  listID: prop_types_1.default.string,
  onClick: prop_types_1.default.func,
  onSelect: prop_types_1.default.func,
  data: prop_types_1.default.array.isRequired,
  portalTarget: prop_types_1.default.string
};
exports.ComboButton.defaultProps = {
  open: false
};